// extracted by mini-css-extract-plugin
export default {"rating":"Gy-z","numberOfStars":"Hy-z","count":"Iy-z","barGraphSpacing":"Jy-z","barGraph":"Ky-z"};